import { setAlert } from './alert';
import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT } from './types';
import setAuthToken from '../utils/setAuthToken';
import { store } from '../store';

export const login = ({ token, user }) => async (dispatch) => {
  try {
    dispatch({
      type:    LOGIN_SUCCESS,
      payload: { token, user },
    });

    setAuthToken(store.getState().auth[process.env.REACT_APP_TOKEN_NAME]);
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
    dispatch({ type: LOGIN_FAIL });
  }
};

export const logout = () => (dispatch) => {
  dispatch({ type: LOGOUT });
};
